<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowUp_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13.364 6.834 8.459 1.929a.67.67 0 0 0-.919 0L2.636 6.834a.65.65 0 0 0 .748 1.042L7 6.079V13a1 1 0 0 0 2 0V6.079l3.616 1.797a.65.65 0 0 0 .748-1.042"
    />
</svg>
